<div class="member-view">
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
  </div>
  
  <div class="modal-body">
    <div class="name">{{data.companyName}}</div>
    <div class="ename">{{data.companyNameEng}}</div>
    
    <div class="info1">
      <div class="section-title">기본정보</div>
      
      <table class="info-table">
      <colgroup>
        <col style="width:16%;">
        <col style="width:34%;">
        <col style="width:16%;">
        <col style="width:34%;">
      </colgroup>
      
      <tbody>
      <tr>
        <th>대표자(한글)</th>
        <td>{{data.ceoName}}</td>
        <th>대표자(영문)</th>
        <td>{{data.ceoNameEng}}</td>
      </tr>   
      <tr>
        <th>이메일</th>
        <td>{{data.email}}</td>
        <th>Web Site</th>
        <td><a href="http://{{data.homepage}}" target="_blank" class="link2">{{data.homepage}}</a></td>
      </tr> 
      <tr>
        <th>주소</th>
        <td colspan="3">{{data.address}} {{data.addressDetail}}</td>        
      </tr>   
      <tr>
        <th>전화번호</th>
        <td colspan="3">{{data.tel}}</td>     
      </tr> 
      <tr>
        <th>업종</th>
        <td>{{data.job}}</td>
        <th>업태</th>
        <td>{{data.job1}}</td>
      </tr> 
      </tbody>
      </table>
    </div>

	  <div class="info2">
	    <div class="section-title">회사 소재지</div>
	    
	    <table class="info-table">
	    <colgroup>
	      <col style="width:16%;">
	      <col style="width:13%;">
	      <col style="width:29%;">
	      <col style="width:13%;">
	      <col style="width:29%;">
	    </colgroup>
	    
	    <tbody>
	    <tr>
	      <th rowspan="2" class="color-no">본사</th>
	      <th>주소</th>
	      <td colspan="3">{{data.address}}</td>
	    </tr>   
	    <tr>
	      <th>전화</th>
	      <td>{{data.tel}}</td>
	      <th>팩스</th>
	      <td>{{data.fax}}</td>
	    </tr> 
	    <tr>
	      <th rowspan="2" class="color-no">공장</th>
	      <th>주소</th>
	      <td colspan="3">{{data.addressFactory}}</td>
	    </tr>   
	    <tr>
	      <th>전화</th>
	      <td>{{data.telFactory}}</td>
	      <th>팩스</th>
	      <td>{{data.faxFactory}}</td>
	    </tr> 
	    <tr>
	      <th rowspan="2" class="color-no">사무소</th>
	      <th>주소</th>
	      <td colspan="3">{{data.addressOffice}}</td>
	    </tr>   
	    <tr>
	      <th>전화</th>
	      <td>{{data.telOffice}}</td>
	      <th>팩스</th>
	      <td>{{data.faxOffice}}</td>
	    </tr> 
	    </tbody>
	    </table>
	  </div>
	  
    <div class="info3">
      <div class="section-title">제품 소개</div>
      
      <table class="info-table">
      <colgroup>
        <col style="width:16%;">
        <col style="width:13%;">
        <col style="width:71%;">
      </colgroup>
      
      <tbody>
      <tr>
        <th rowspan="2" class="color-no">생산제품</th>
        <th>국문</th>
        <td>{{data.productKor}}</td>
      </tr>   
      <tr>
        <th>영문</th>
        <td>{{data.productEng}}</td>
      </tr> 
      <tr>
        <th rowspan="2" class="color-no">영업제품</th>
        <th>국문</th>
        <td>{{data.salesKor}}</td>
      </tr>   
      <tr>
        <th>영문</th>
        <td>{{data.salesEng}}</td>
      </tr> 
      </tbody>
      </table>
    </div>	  

  </div>
  
  <div class="modal-footer">
    <button class="close-btn" (click)="activeModal.dismiss()">닫기</button>  
  </div>
</div>